import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Section_9.css";

const Section_9 = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await axios.get("https://urbancasabackendfiles.onrender.com/api/faqs");
        setFaqs(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load FAQs. Please try again.");
        setLoading(false);
      }
    };
    fetchFAQs();
  }, []);

  return (
    <div className="section-9-main-container">
      <div className="faq-section">
        <h2 className="faq-title">Frequently Asked Questions (FAQs)</h2>
        
        {loading ? <p>Loading FAQs...</p> : null}
        {error ? <p className="error">{error}</p> : null}

        <div className="faq-container">
          {faqs.length > 0 ? (
            faqs.map((faq, index) => (
              <div key={index} className="faq-card">
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))
          ) : (
            <p>No FAQs available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Section_9;
